import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TSelectedSubType, TSelectedType } from './HomePage'

interface IState {
  isNewVehicle: boolean
  selectedType: TSelectedType
  selectedSubType: TSelectedSubType
  vehicleNumber: string
}

const initialState: IState = {
  isNewVehicle: false,
  selectedType: 'private',
  selectedSubType: 'car',
  vehicleNumber: '',
}

const homePageSlice = createSlice({
  name: 'homePageSlice',
  initialState: initialState,
  reducers: {
    updateIsNewVehicle: (
      state,
      action: PayloadAction<{
        isNewVehicle: boolean
      }>,
    ) => {
      const { isNewVehicle } = action.payload
      state.isNewVehicle = isNewVehicle
    },
    updateSelectedType: (state, action: PayloadAction<TSelectedType>) => {
      state.selectedType = action.payload
    },
    updateSelectedSubType: (state, action: PayloadAction<TSelectedSubType>) => {
      state.selectedSubType = action.payload
    },
    updateVehicleNumber: (state, action: PayloadAction<string>) => {
      state.vehicleNumber = action.payload
    },
  },
})

const { reducer } = homePageSlice

const { updateIsNewVehicle, updateSelectedType, updateSelectedSubType, updateVehicleNumber } =
  homePageSlice.actions

export {
  reducer as homePageReducer,
  updateSelectedType,
  updateSelectedSubType,
  updateVehicleNumber,
  updateIsNewVehicle,
}
